import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FlagPrincipalFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Field name='flagPrincipal'>
          {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagPrincipal' label='Principal' />}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FlagPrincipalFormGroup)
